import React, { useState, useEffect } from 'react';
import { ImageOff, Loader2 } from 'lucide-react';

// =====================================================================
// Miniatura de uma foto guardada no SharePoint — componente COMPARTILHADO, sem
// dono: Manutenção (Certificação e Conservação Predial), Chamados, Compras,
// Financeiro (Registro de Nulos) e Logística (Retirada) importam este arquivo.
//
// ⚠️ Mora na raiz de `src/components/` justamente por não ser de módulo nenhum.
// Nasceu dentro de `manutencao/` e ficou lá enquanto era só de lá; quando o
// quinto módulo passou a usá-lo, o endereço virou mentira e ele subiu (15/09).
//
// A `webUrl` do SharePoint é AUTENTICADA — não carrega direto num <img src>.
// Por isso buscamos os bytes pelo PROXY do backend (GET <apiBase>/foto?url=,
// que tem o token do Graph), convertemos em blob e exibimos via objectURL.
// Mesmo padrão do Destaque do Mês; é o que faz a imagem aparecer na tela.
//
// ⚠️ `apiBase` é OBRIGATÓRIA e é o prefixo do submódulo DONO da foto: cada um
// tem o seu proxy, com o seu confinamento de pasta no SharePoint e a sua regra
// de acesso (na Certificação, o Gerente só vê foto de relatório da própria
// loja). Apontar para o proxy do outro submódulo dá 404, não foto trocada.
//
// Clicar abre a imagem em tamanho cheio numa aba nova (o próprio blob) — sem
// depender de o usuário ter sessão do M365 no navegador.
// =====================================================================

const auth = () => ({ Authorization: `Bearer ${localStorage.getItem('authToken')}` });

const ImagemSharePoint = ({ apiBase, url, alt = 'Foto', size = 64, radius = 6, borderColor = '#e2e8f0' }) => {
  const [src, setSrc] = useState('');
  const [estado, setEstado] = useState('carregando'); // carregando | ok | erro

  useEffect(() => {
    let vivo = true;
    let objectUrl;
    (async () => {
      setEstado('carregando');
      try {
        const r = await fetch(`${apiBase}/foto?url=${encodeURIComponent(url)}`, { headers: auth() });
        if (!r.ok) throw new Error();
        const blob = await r.blob();
        objectUrl = URL.createObjectURL(blob);
        if (vivo) { setSrc(objectUrl); setEstado('ok'); }
        else URL.revokeObjectURL(objectUrl);
      } catch {
        if (vivo) setEstado('erro');
      }
    })();
    // Revoga o objectURL ao desmontar/trocar a url — senão vaza memória.
    return () => { vivo = false; if (objectUrl) URL.revokeObjectURL(objectUrl); };
  }, [apiBase, url]);

  const base = {
    width: size, height: size, borderRadius: radius, border: `1px solid ${borderColor}`,
    display: 'inline-flex', alignItems: 'center', justifyContent: 'center',
    background: '#f8fafc', color: '#94a3b8', flexShrink: 0,
  };

  if (estado === 'carregando') {
    return <span style={base}><Loader2 size={16} className="spin" /></span>;
  }
  if (estado === 'erro') {
    return <span style={base} title="Não foi possível carregar a foto"><ImageOff size={16} /></span>;
  }
  return (
    <img src={src} alt={alt} title="Clique para ampliar"
      onClick={() => window.open(src, '_blank', 'noopener')}
      style={{ width: size, height: size, objectFit: 'cover', borderRadius: radius, border: `1px solid ${borderColor}`, cursor: 'zoom-in', display: 'block' }} />
  );
};

export default ImagemSharePoint;
